import React from "react";
import PropTypes from "prop-types";

const ErrorCodeResolver = ({ codes, children }, context) => {
  let errorMessage = null;

  if (codes?.mint_voucher) {
    codes?.mint_voucher.map((errorCode) => {
      switch (errorCode) {
        case "Invalid Code":
          errorMessage = (
            <p>{context.t("The provided voucher code is not valid")}</p>
          );
          break;
        case "Code already used":
          errorMessage = (
            <p>
              {context.t(
                "The provided voucher code got already used. Each voucher code can be used only once."
              )}
            </p>
          );
          break;
      }
    });
  } else if (codes?.bowline_relay_transaction) {
    codes?.bowline_relay_transaction.map((errorCode) => {
      switch (errorCode) {
        case "already sent, please check status":
          errorMessage = (
            <p>
              {context.t(
                "Your transaction was already sent to the blockchain. It looks like you tried to mint the same token again. Please be patient."
              )}
              <br />
              {context.t(
                "If you tried to mint more than one Token, you've might got caught by our bot protection. We will manually review your transaction and airdrop you the token later."
              )}
            </p>
          );
          break;
      }
    });
  } else if (codes?.bowline_relay) {
    codes?.bowline_relay.map((errorCode) => {
      if (
        errorCode.startsWith("err: max fee per gas less than block base fee")
      ) {
        errorMessage = (
          <>
            <p>
              {context.t(
                "We could not airdrop your toke at this moment because there is too much traffic on the blockchain right now. However, your airdrop was successfully added to the queue, and you´ll receive your token once the transaction was written to the blockchain. This can take up to a few hours depending on queue length and gas."
              )}
            </p>
            <p>
              <strong>{context.t("Attention:")}</strong>{" "}
              {context.t(
                "We can't guarantee the exact order of the transactions."
              )}
            </p>
          </>
        );
      }
    });
  }

  return (
    <>
      {errorMessage}
      {!errorMessage && children}
    </>
  );
};

ErrorCodeResolver.propTypes = {
  codes: PropTypes.any,
  children: PropTypes.any,
};

ErrorCodeResolver.defaultProps = {};

ErrorCodeResolver.contextTypes = {
  t: PropTypes.func,
};
export default ErrorCodeResolver;
